import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import actions from '../../actions/AlertsBurstActions';
import IntensityNoiseGraph from '../SensorsTabs/IntensityNoiseGraph';

const AlertsBurstSampleStrip = (props, context) => {
  const { sample, noiseGraphData, timeZone, uiInfo } = props;
  const dispatch = useDispatch();

  const closePanel = () => {
    dispatch(actions.selectBurstAlertSample(undefined));
  };

  // Only one graph on the strip, so shrink the strip to ~half the map width and
  // centre it (the default full-width strip leaves the graph stretched out).
  const graphWidth = uiInfo ? Math.round(0.3 * uiInfo.pageWidth) : 380;
  const stripStyle = {
    width: graphWidth + 30,
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)',
  };

  return (
    <div className='sample-info' style={stripStyle}>
      <i className='icon-close' onClick={closePanel} />
      <div className='sample-graphs'>
        <div className='graph-div'>
          <IntensityNoiseGraph
            data={noiseGraphData}
            sampleTime={sample?.time_stamp}
            timeZone={timeZone}
            width={graphWidth}
            height={260}
            threshold={sample?.threshold_rms}
            thresholdLabel={context.t('threshold_rms')}
          />
        </div>
      </div>
    </div>
  );
};

AlertsBurstSampleStrip.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default AlertsBurstSampleStrip;
